module.exports = __webpack_public_path__ + "static/media/facebook.2131f451.svg";